  export function convertNumber(number, lang = 'en') {
    // Bengali numeral mappings
    const bengaliNumerals = {
        '0': '০',
        '1': '১',
        '2': '২',
        '3': '৩',
        '4': '৪',
        '5': '৫',
        '6': '৬',
        '7': '৭',
        '8': '৮',
        '9': '৯'
    };
    
    // Convert single digit
    function convertDigit(digit, language) {
        if (language === 'bn') {
            return bengaliNumerals[digit] || digit;
        }
        return digit;
    }
    
    // Convert a number (could be multi-digit)
    function convertNumberString(numStr, language) {
        return numStr.split('').map(digit => convertDigit(digit, language)).join('');
    }
    
    // Handle array input
    if (Array.isArray(number)) {
        return number.map(num => {
            if (typeof num === 'number') {
                return convertNumberString(num.toString(), lang);
            }
            return convertNumberString(num, lang);
        });
    }
    
    // Handle single number input
    if (typeof number === 'number') {
        return convertNumberString(number.toString(), lang);
    }
    
    // Handle string input
    return convertNumberString(number, lang);
}